import React from "react";
import {RespDispatchContext} from '../providers';

function useDispatchResp() {
    return React.useContext(RespDispatchContext);
}

export {useDispatchResp}
